// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0322062d","455":"0a49466f","977":"ca9621de"}[chunkId] + ".chunk.js";
};